import {GetBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

const HERO_IMAGE =
  'https://cdn.aboutstatic.com/file/8b52d4f5eccc56d4b0e211d0f04531e0.jpg?quality=75&height=430&width=860';

export const articleDetailBannerMock: GetBannerResponse = {
  banner: {
    variant: {
      $case: 'highlightBanner',
      highlightBanner: {
        headline: '-20% on this look',
        subline: 'Style it now and save with code STYLE20',
        colors: {
          foregroundColor: {hex: '#FFFFFF'},
          backgroundColor: {hex: '#4C1D95'},
        },
        gradientColors: ['#7C3AED', 'rgba(124, 58, 237, 0)'],
        media: {
          backgroundColor: '#4C1D95',
          variant: {
            $case: 'image',
            image: {
              url: HERO_IMAGE,
              description: 'Banner hero',
              external: false,
            },
          },
        },
        cta: {
          label: 'Apply code',
          colors: {
            foregroundColor: {hex: '#4C1D95'},
            backgroundColor: {hex: '#FFFFFF'},
          },
        },
        infoIcon: {
          headline: 'About this offer',
          content: {
            text: 'STYLE20 applies automatically at checkout for this item.',
          },
        },
        productImages: [],
        isAd: false,
        tracker: {
          promotionId: 'mock-adp-banner',
          promotionName: 'Mock ADP Banner',
          creativeName: 'highlight',
          creativeSlot: 'adp-buying-box',
        },
      },
    },
  },
};
